// extracted by mini-css-extract-plugin
export default {"chrome__btn":"ChromeExtension_chrome__btn__sW3Up","blue__btn":"ChromeExtension_blue__btn__KfIjt"};